import React from 'react';
import {BrowserRouter as Router, Route, Redirect} from 'react-router-dom'

import {config} from './config';
import {getSettings} from './fetch';

import './App.css';

import AsyncComponent from './AsyncComponent';

import AppHeader from './AppHeader';
import LoginForm from './LoginForm/LoginForm';
import Dashboard2 from './Dashboard2';
import MainNav from './MainNav/MainNav';
//import Students from './Students';
const AsyncStudents = AsyncComponent(() => import("./Students"));
//import Settings from './Settings';
const AsyncSettings = AsyncComponent(() => import("./Settings"));
//import GradeReports from './GradeReports';
const AsyncGradeReports = AsyncComponent(() => import("./GradeReports"));

class App extends React.Component {
  constructor(props) {
    super(props);
    this.verifyUser();
    this.state = {
      message: '',
      user: {},
      tokenOk: this.checkToken(),
      readOnly: true,
      isCollapsed: {
        userList: window.localStorage.getItem("isCollapsed") && JSON.parse(window.localStorage.getItem("isCollapsed")).userList || false,
        mainNav: window.localStorage.getItem("isCollapsed") && JSON.parse(window.localStorage.getItem("isCollapsed")).mainNav || false,
      }
    };

    this.checkToken = this.checkToken.bind(this);
    this.setToken = this.setToken.bind(this);
    this.verifyUser = this.verifyUser.bind(this);
    this.sendEmail = this.sendEmail.bind(this);

    this.handleCollapseUserList = this.handleCollapseUserList.bind(this);
    this.handleCollapseMainNav = this.handleCollapseMainNav.bind(this);
  }

  handleCollapseUserList() {
    this.setState((prevState) => ({
      isCollapsed: {
        ...prevState.isCollapsed,
        userList: !prevState.isCollapsed.userList
      }
    }), function() { // accessing state froma a callback function
      window.localStorage.setItem("isCollapsed", JSON.stringify(this.state.isCollapsed));
    });
  }

  handleCollapseMainNav() {
    this.setState((prevState) => ({
      isCollapsed: {
        ...prevState.isCollapsed,
        mainNav: !prevState.isCollapsed.mainNav
      }
    }), function() { // accessing state froma a callback function
      window.localStorage.setItem("isCollapsed", JSON.stringify(this.state.isCollapsed));
    });
  }

  checkToken() {
    var localToken = window.localStorage.getItem("token");
    if (localToken) {return true}
    return false;
  }

  setToken(user) {
    this.setState((prevState, props) => (
        {
            ...prevState,
            user: user,
            tokenOk: this.checkToken(),
            readOnly: (user && user.objectClass.indexOf('posixAccount') !== -1) ? false : true,
        }));
  }

  async sendEmail(){
      const serviceId = 'service_4qrko18';
      const templateId = 'template_78c4bev';
      const publicKey = 'gEiryKIVYsnseJJxl';

      const data = {
        service_id: serviceId,
        template_id: templateId,
        user_id: publicKey,
        template_params: {
          from_name: 'Internacionalna Škola Beograd - ISB',
          from_email: 'nikola.srebric@gbi.rs',
          to_email: 'jovanovicv420@gmail.com',
          message: 'Server pao, mora da se podigne!',
        }
      };

  try {
      const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {

        const errorText = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
      }

      const contentType = response.headers.get('Content-Type');
      let result;
      
      if (contentType && contentType.includes('application/json')) {
        result = await response.json();
      } else {

        result = await response.text();
        console.log('Non-JSON response:', result);
      }
    
      console.log('Email sent successfully:', result);
    
    } catch (error) {
      console.error('Failed to send email:', error);
    }
  }

  //OLD VERIFY BEZ SLANJA EMAILA
  // verifyUser() {
  //   var that = this;
  //   var token = window.localStorage.getItem('token');
  //   fetch(config.apiHost + ':' + config.apiPort + '/verify-user', {
  //       method: 'post',
  //       headers: {
  //           'Accept': 'application/json',
  //           'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify({"token": token})
  //   }).then(function(response, err) {
  //       if (!response.ok) {
  //           throw Error(response.statusText);
  //       }
  //       return response.json();
  //   }).then(function(data) {
  //       if (data.message) {
  //         that.setState({
  //             message: data.message
  //         });
  //       } else {
  //         that.setState({
  //             message: 'OK, cool'
  //         });
  //         that.setState((prevState, props) => (
  //             {
  //                 ...prevState,
  //                 user: data.user,
  //                 tokenOk: that.checkToken(),
  //                 //readOnly: prevState.readOnly,
  //                 readOnly: (data.user && data.user.objectClass.indexOf('posixAccount') !== -1) ? false : true,
  //             }));
  //       }
  //   }).catch(function(error) {
  //     console.log('this in catch:', this); // Verify `this` context
  //       //console.log('errrrrrrrrr', error);
  //         that.setState({
  //             //message: error
  //             message: {message:'Network issue. Is server up?'}
  //         });
  //   });
  // }

    verifyUser() {
      var token = window.localStorage.getItem('token');
      fetch(`${config.apiHost}:${config.apiPort}/verify-user`, {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ "token": token })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then(data => {
        if (data.message) {
          this.setState({
            message: data.message
          });
        } else {
          this.setState({
            message: 'OK, cool',
            user: data.user,
            tokenOk: this.checkToken(),
            readOnly: (data.user && data.user.objectClass.indexOf('posixAccount') !== -1) ? false : true,
          });
        }
      })
      .catch(error => {
        console.error('Error during verification:', error);
        // console.log('Ovo je u catch:', this);
        this.setState({
          message: 'Network issue. Is server up?'
        });
        // this.sendEmail();
      });
    }


   render() {
    return (
      <Router>
        {this.checkToken() ? (
          <div className="App">
            <Route exact path="/" render={({location}) => ( <Redirect to="/dashboard" />)} />
            <Route path="/" render={({location}) => (
              <MainNav
                location={location}
                setToken={this.setToken}
                user={this.state.user}
                isCollapsed={this.state.isCollapsed}
                handleCollapse={this.handleCollapseMainNav}
              />
            )} />
            <Route exact path="/login" render={({location}) => ( <Redirect to="/dashboard" />)} />

            <main className={this.state.isCollapsed.mainNav ? "main collapsed-main-nav" : "main"}>
              <Route path="/students" render={({location}) => (
                <AsyncStudents
                  location={location}
                  user={this.state.user}
                  readOnly={this.state.readOnly}
                  handleCollapse={this.handleCollapseUserList}
                  isCollapsed={this.state.isCollapsed}
                />
              )} />
        <Route path="/grade-reports" component={AsyncGradeReports} />
              <Route path="/dashboard" render={() => (
                <Dashboard2 user={this.state.user} readOnly={this.state.readOnly} />
              )} />
              <Route path="/settings" render={() => (<AsyncSettings user={this.state.user} /> )} />
            </main>

          </div>
        ) : 
          <div>
            <Redirect to="/login" />
            <LoginForm message={this.state.message} setToken={this.setToken} />
          </div>
        }
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js